import * as $ajax from './_ajax'
import * as $helpers from './_helpers'
import * as $msg from './_msg'
import * as $resources from './_resources'
import * as $ubh from './_uniformboxheights'
import * as $blogpostpopup from './blog.blogpostpopup'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $.extend(true, {}, $options)

    new $ubh.uniformBoxHeights({
        listElementsSelector: '.' + options.pagePrefix + '-account-row > div > .bcfla-box',
        sizesToSkip: ['xs', 'xxs'],
    })

    $helpers.makeCaptchaReloadable(elem('changepassword-captcha-image'))

    elem('account-save').click(function () {
        saveAccountChanges()
    })

    elem('changepassword-save').click(function () {
        changePassword()
    })

    $blogpostpopup.load(6)
}

function changePassword(): void {
    $ajax.post({
        loadingText: 'Byter lösenord...',
        url: $resources.url.account.changePassword,
        data: {
            guid: elem('guid').val(),
            oldpassword: elem('changepassword-old').val(),
            password1: elem('changepassword-new1').val(),
            password2: elem('changepassword-new2').val(),
            captcha: elem('changepassword-captcha').val(),
        },
        success: function (res) {
            if (res.Ok) {
                $msg.show(res.Message)
            } else {
                $msg.showError(res.Message)
            }
        },
    })
}

function saveAccountChanges(): void {
    $ajax.post({
        loadingText: 'Sparar...',
        url: $resources.url.account.myPageSave,
        data: {
            guid: elem('guid').val(),
            firstname: elem('firstname').val(),
            lastname: elem('lastname').val(),
            email: elem('email').val(),
        },
        success: function (res) {
            if (res.Ok) {
                $msg.show(res.Message)
            } else {
                $msg.showError(res.Message)
            }
        },
    })
}

function elem(id: string): JQuery {
    return $('#' + options.pagePrefix + '-' + id)
}
